import React from 'react';
import { Button } from 'app/components';
import './style';

const Banner = () => {
  return (
    <div className="relative w-full h-[512px] bg-black text-white flex flex-col justify-center hidden md:flex">
    {/* Green Banner */}
    <div className="absolute top-[80px] left-[130px] flex items-center gap-2 pl-4 pr-0 py-2 bg-[#E5FFF6] rounded-full w-[520px] whitespace-nowrap">
      {/* Icon Container */}
      <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full">
      <img
        src="assets/images/Sparkle.svg"
        alt="Sparkle Icon"
        className="w-4 h-4"
        style={{ filter:
          "brightness(0) saturate(100%) invert(56%) sepia(98%) saturate(357%) hue-rotate(97deg) brightness(65%) contrast(101%)" }}
      />
      </div>

      {/* Text */}
      <span className="text-[#009D64] text-[16px] font-medium">
        Calling All Event Organizers! Your Ticketing Solution Is Here!
      </span>
    </div>

    {/* Title (Reduced Top Margin) */}
    <div className="absolute left-[130px] top-[165px]">
      <h1 className="text-[40px] md:text-[64px] font-bold leading-[125%] max-w-[1151px] text-left">
        Create Events, Sell Tickets, Grow Your Audience – All for{" "}
        <span className="text-[#FF2459]">
          Free!
        </span>
      </h1>
    </div>

    <div className="absolute left-[130px] top-[380px]">
      <Button type="primary" rounded="true"
        onClick={() => {
          window.open(
            "/landing",
            "_blank",
            "noopener,noreferrer"
          );
        }}
      >
        List your event
      </Button>
    </div>
  </div>

  );
};

export default Banner;
